import { render } from "./TabPlantDetailsPlotDates.vue?vue&type=template&id=f972ee9e"
import script from "./TabPlantDetailsPlotDates.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsPlotDates.vue?vue&type=script&lang=js"

import "./TabPlantDetailsPlotDates.vue?vue&type=style&index=0&id=f972ee9e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__